import axiosInstance from "../../apiAxios/axiosInstance";

export const SupplierList = async (payload) => {
  const response = await axiosInstance.post("/vendor/supplier-list", payload);
  return response.data;
};
export const ActiveSupplierList = async(payload) => {
   const resposne=await axiosInstance.post("/vendor/active-supplier-list",payload);
   return resposne.data
};
export const AddSupplier = async (payload) => {
  const response = await axiosInstance.post("/vendor/supplier-store", payload);
  return response.data;
};

export const ViewSupplier = async (payload) => {
  const response = await axiosInstance.post("/vendor/supplier-show", payload);
  return response.data;
};

export const UpdateSupplier = async (payload) => {
  const response = await axiosInstance.post("/vendor/supplier-update", payload);
  return response.data;
};

export const DeleteSupplier = async (payload) => {
  const response = await axiosInstance.post("/vendor/supplier-delete", payload);
  return response.data;
};

export const SupplierChangeStatus = async (payload) => {
  const response = await axiosInstance.post(
    "/vendor/supplier-status-update",
    payload
  );
  return response.data;
};